<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/vacaciones">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Vacaciones</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <h1>Edición vacaciones {{ vacacion }}</h1>
                    </div>
                    <div class="item-Form">
                        <div class="panel-body">
                            <form class="form-horizontal" enctype="multipart/form-data" id="formGeneralLeave" method="post" role="form" novalidate="novalidate">
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="fechaDesde">Fecha Desde</label>
                                        <br />
                                        <date-picker 
                                            class="dateTimePicker"
                                            v-model="fechaDesde"    
                                            value-type="format"
                                            :editable="false"
                                            :formatter="momentFormat"
                                            :clearable = "false"
                                        ></date-picker>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <label for="fechaHasta">Fecha Hasta</label>
                                        <br />
                                        <date-picker
                                            class="dateTimePicker"
                                            v-model="fechaHasta" 
                                            value-type="format"
                                            :editable="false"
                                            :formatter="momentFormat"
                                            :clearable = "false"
                                        ></date-picker>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-6 col-xs-12">
                                        <label for="numDias">Total Días</label>
                                        <input class="form-control" id="numDias" name="numDias" readonly="readonly" type="text" :value="numDias">
                                    </div>
                                </div>
                                
                                <hr />

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <label for="observaciones">Observaciones</label>
                                        <textarea class="form-control" cols="20" id="observaciones" name="observaciones" v-model="observaciones" rows="5"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12"></div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <div v-if="superaMaximoDias" class="text-danger">
                                            Aviso.- El total de días no puede superar los días de vacaciones pendientes (<strong>{{ maximoDias }} día/s</strong>)
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <input :disabled="!datosValidos || enviandoDatosFormulario" type="submit" class="btn btn-lg btn-primary" id="btnSave" :value="textoBtnEnvio">
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";
    import moment from "moment";

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/es';


    export default {
        name: "EdicionVacaciones",
		components: {
            Encabezado,
            Footer,
            DatePicker
        },
		data() { 
			return{
                idVacacionesSeleccionadas: null,
                fechaDesde: moment(new Date()).format('L'),
                fechaHasta: moment(new Date()).format('L'),
                observaciones: null,
                momentFormat: {
                    //[optional] Date to String
                    stringify: (date) => {
                        return date ? moment(date).format('L') : ''
                    },
                    //[optional]  String to Date
                    parse: (value) => {
                        return value ? moment(value, 'L').toDate() : null
                    },
                    //[optional] getWeekNumber
                    getWeek: (date) => {
                        return // a number
                    }
                }
            }
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
            
            this.idVacacionesSeleccionadas = this.vacacion.id;
            this.fechaDesde= moment(this.vacacion.fechaDesde).format('L');
            this.fechaHasta= moment(this.vacacion.fechaHasta).format('L');
            this.observaciones= this.vacacion.observaciones;
		},
        watch:{
            fechaDesde: function(){
                if (this.numDias<0){
                    this.fechaHasta = this.fechaDesde;
                }
            },
            fechaHasta: function(){
                if (this.numDias<0){
                    this.fechaHasta = this.fechaDesde;
                }
            }
        },
		computed:{
            vacaciones: function(){
				let vacaciones = this.$store.state.perfil.vacaciones.registros || [];
			
                return (Array.isArray(vacaciones))? vacaciones : [vacaciones];
			},
			vacacion: function(){
                let vacacion = null;

                //console.log(this.$route.params.id_vacaciones);

				if (this.vacaciones.length > 0){
                    vacacion = this.vacaciones.find(vacacion_=>{
                        return vacacion_.id == this.$route.params.id_vacaciones;
                    });
				}

                return vacacion;
			},
            numDias: function(){
                let desde = moment(this.fechaDesde, 'L');
                let hasta = moment(this.fechaHasta, 'L');

                let dias = hasta.diff(desde, 'days');
                
                return dias + 1;
            },
            maximoDias: function(){
                let resumenVacaciones = this.$store.state.perfil.vacaciones.resumen || [];
                
                resumenVacaciones = (Array.isArray(resumenVacaciones))? resumenVacaciones : [resumenVacaciones];

                return resumenVacaciones.reduce((a, b)=> a + b.diasPendientes * 1, 0);
            },
            superaMaximoDias: function(){
                return this.numDias > this.maximoDias;
            },
            datosValidos: function(){
                return (!this.superaMaximoDias);
            },
            textoBtnEnvio: function() {
                return (this.datosValidos)? 'Enviar': 'Revise Avisos';
            }
		},
        methods:{
            formatDate: function (date) {
				return this.moment(date).format('DD/MM/YYYY hh:mm');
			},
            enviarDatosFormulario: function(){
                let datosFormularioEdicionVacaciones = {
                    idVacacionesSeleccionadas: this.idVacacionesSeleccionadas,
                    fechaDesde: this.fechaDesde,
                    fechaHasta: this.fechaHasta,
                    observaciones: this.observaciones
                };

                this.$store.dispatch({
                        type: 'enviarDatosEdicionVacaciones',
                        payload: datosFormularioEdicionVacaciones
                    }
                );
            }
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
    .dateTimePicker{
        width:100%;
    }
</style>
